import React from 'react';
import './Localizacao.css';
import clinicaConfig from "../../clinicaConfig.js";
import { FaClock, FaMapMarkerAlt, FaWhatsapp, FaCalendarAlt, FaRegClock } from 'react-icons/fa';

function Localizacao() {
  return (
    <section className="localizacao-section">
      <div className="localizacao-container">
        
        <div className="localizacao-header">
          <h2 className="localizacao-title">Onde Estamos</h2>
          <p className="localizacao-subtitle">Visite-nos ou entre em contato</p>
        </div>

        <div className="localizacao-content">
          
          <div className="localizacao-card horario-card">
            <div className="card-icon-wrapper">
              <FaClock className="card-icon" />
            </div>
            <h3 className="card-title">Horário de Funcionamento</h3>
            
            <div className="horario-details">
              <div className="horario-item">
                <div className="horario-dia">
                  <FaCalendarAlt className="horario-icon-small" />
                  <span className="horario-label">{clinicaConfig.diaDefuncionamento}</span>
                </div>
                <div className="horario-periodo">
                  <FaRegClock className="horario-icon-small" />
                  <span className="horario-value">{clinicaConfig.HoraDefuncionamento}</span>
                </div>
              </div>
              
              <div className="horario-extra-info">
                <p className="info-text">Entre em contato para esclarecer dúvidas</p>
                <p className="info-text">Verifique se há necessidade de preparo para o exame</p>
                <p className="info-text">Chegue com 10 minutos de antecedência</p>
              </div>
            </div>
            
            <div className="card-footer">
              <span className="status-badge">Estamos prontos para atendê-lo!</span>
            </div>
          </div>

          <div className="localizacao-card mapa-card">
            <div className="card-icon-wrapper">
              <FaMapMarkerAlt className="card-icon" />
            </div>
            <h3 className="card-title">Nossa Localização</h3>
            
            <div className="mapa-wrapper">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3930.449202385992!2d-39.0274852!3d-9.8964942!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x70c49006efa6001%3A0x8579e6dd1ce540cb!2sCl%C3%ADnica%20Samec%20De%20Canudos!5e0!3m2!1spt-BR!2sbr!4v1770766848343!5m2!1spt-BR!2sbr"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Mapa da Clínica"
                className="mapa-iframe"
              ></iframe>
            </div>

            <div className="endereco-info">
              <div className="endereco-detailed">
                <div className="endereco-linha">
                  <span className="endereco-label">Endereço:</span>
                  <span className="endereco-valor">Avenida: Santo Antônio, 232-322</span>
                </div>
                <div className="endereco-linha">
                  <span className="endereco-label">Cidade:</span>
                  <span className="endereco-valor">Canudos - BA</span>
                </div>
              </div>
              
              <div className="contato-actions">
                <a href="https://maps.app.goo.gl/XBEfHCtoacsT494X9" target="_blank" rel="noreferrer" className="contato-btn maps">
                  <FaMapMarkerAlt />
                  <span>Ver no Maps</span>
                </a>
                <a href={`https://wa.me/${clinicaConfig.whatsapp}`} target="_blank" rel="noreferrer" className="contato-btn whatsapp">
                  <FaWhatsapp />
                  <span>WhatsApp</span>
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Localizacao;